import styled from 'styled-components';
import ForbiddenIconImg from '../assets/images/screens/Forbidden/warning.svg';

const Forbidden = () => {
	return (
		<Content>
			<ForbiddenIcon />
			<Title>
				페이지에 <TitleHighlight>접근할 수 없습니다.</TitleHighlight>
			</Title>
		</Content>
	);
};

export default Forbidden;

const Content = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	width: 100%;
	flex: 1;
	background-color: white;
	gap: 30px;
`;

const ForbiddenIcon = styled.i`
	width: 55px;
	height: 55px;
	background-image: url(${ForbiddenIconImg});
	background-size: contain;
	background-repeat: no-repeat;
	background-position: center;
`;

const Title = styled.h1`
	font-size: 28px;
	font-weight: 700;
`;

const TitleHighlight = styled.span`
	color: #22499d;
`;
